import HotelsDiscovery from './HotelsDiscovery'

export default HotelsDiscovery
